export function formatMonth(value: number): string {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  if (value < 1 || value > 12) {
    throw new Error("Nilai harus antara 1 dan 12");
  }

  return months[value - 1];
}
